import { render } from "./DictionaryReportsList.vue?vue&type=template&id=1ac1662a&scoped=true"
import script from "./DictionaryReportsList.vue?vue&type=script&lang=js"
export * from "./DictionaryReportsList.vue?vue&type=script&lang=js"

import "./DictionaryReportsList.vue?vue&type=style&index=0&id=1ac1662a&scoped=true&lang=scss"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac1662a"]])

export default __exports__